import { render, staticRenderFns } from "./cart-item-dialog.vue?vue&type=template&id=12cdf962&scoped=true&"
import script from "./cart-item-dialog.vue?vue&type=script&lang=js&"
export * from "./cart-item-dialog.vue?vue&type=script&lang=js&"
import style0 from "./cart-item-dialog.vue?vue&type=style&index=0&id=12cdf962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cdf962",
  null
  
)

export default component.exports